module.exports = __webpack_public_path__ + "static/media/roll-dice-70.97152ef1.png";